module.exports = __webpack_public_path__ + "static/img/grant-circle-logo.1acd4dbe.png";